package com.shadowings.gero.presentation.component

import androidx.compose.material3.AlertDialog
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.semantics.semantics
import androidx.compose.ui.semantics.testTag
import androidx.compose.ui.text.font.FontWeight
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.feature_unavailable_ok
import gero.composeapp.generated.resources.feature_unavailable_web_text
import gero.composeapp.generated.resources.feature_unavailable_web_title
import org.jetbrains.compose.resources.stringResource

/**
 * Shown when the user taps a feature that exists conceptually (e.g. buying the Pro version)
 * but isn't implemented on the current platform yet (web has no native billing/store).
 */
@Composable
fun FeatureUnavailableDialog(
    onDismiss: () -> Unit,
    modifier: Modifier = Modifier,
) {
    AlertDialog(
        onDismissRequest = onDismiss,
        modifier = modifier.semantics { testTag = "feature_unavailable_dialog" },
        title = {
            Text(
                text = stringResource(Res.string.feature_unavailable_web_title),
                fontWeight = FontWeight.Bold
            )
        },
        text = {
            Text(text = stringResource(Res.string.feature_unavailable_web_text))
        },
        confirmButton = {
            TextButton(
                onClick = onDismiss,
                modifier = Modifier.semantics { testTag = "feature_unavailable_btn_ok" }
            ) {
                Text(text = stringResource(Res.string.feature_unavailable_ok))
            }
        }
    )
}
